"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var openMainActiveScroll = function (element) {
    if (window.TEvent !== undefined) {
        var eventHandler_1 = function () {
            window.TEvent.touchStartEvent();
        };
        element.addEventListener('touchstart', eventHandler_1);
        return function () {
            openMainDeActiveScroll(element, eventHandler_1);
        };
    }
    return null;
};
exports.openMainActiveScroll = openMainActiveScroll;
var openMainDeActiveScroll = function (element, eventHandler) {
    if (window.TEvent !== undefined) {
        element.removeEventListener('touchstart', eventHandler);
        return eventHandler;
    }
    return null;
};
//# sourceMappingURL=openMainScroll.js.map